import React from 'react';
import { useRouter } from 'next/router';
import { isBrowser, Page } from '@packages/common';
import { useDynamicYieldEvents, setDYPageContextObject } from '@packages/shared';

// This event can be shared between multiple DYContextRenewers
let lastFiredEvent: string | null = null;

export const DYContextRenewer: React.FC<{ page: Page; categoryName?: string }> = ({ page, categoryName, children }) => {
  const { asPath } = useRouter();
  const dynamicYield = useDynamicYieldEvents();
  // Inject DY context to fire SPA event
  if (isBrowser()) {
    // Should not fire on initial page load
    if (lastFiredEvent !== asPath && lastFiredEvent !== null) {
      setDYPageContextObject(asPath, page, categoryName);
      dynamicYield.fireDYSPAPageView(page, asPath, categoryName);
    }
    lastFiredEvent = asPath;
  }
  return <>{children}</>;
};
